/**
 * VISTOERA_CANVAS_FUNCTION_CARD_HOVER_EXPAND_DRAG_PERSISTENCE_AND_CONTEXT_MENU_CONTRACT_V2
 *
 * Global Function Card contract + Media capability extension helpers.
 * Transient UI state only — never persisted to the graph.
 */

/** Conceptual Generate Video / media card phases (orchestration layer). */
export type FunctionCardMediaPhase =
  | 'COLLAPSED_IDLE'
  | 'COLLAPSED_HOVER_PREVIEW'
  | 'EXPANDED_PLAYING'
  | 'EXPANDED_PAUSED'
  | 'DRAGGING_COLLAPSED'
  | 'MODAL'

/** Inspector visible when expanded and not temporarily collapsed for drag. */
export function functionCardShowsInspector(
  isDetailExpanded?: boolean,
  isDragTempCollapsed?: boolean,
): boolean {
  return Boolean(isDetailExpanded && !isDragTempCollapsed)
}

/** Expanded sticky media playback — survives pointer leave until outside collapse. */
export function isStickyMediaPlayback(
  isDetailExpanded?: boolean,
  isDragTempCollapsed?: boolean,
): boolean {
  return functionCardShowsInspector(isDetailExpanded, isDragTempCollapsed)
}

/** True when `target` is inside this node's Function Card chrome (not canvas blank). */
export function isPointerInsideFunctionCard(nodeId: string, target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return Boolean(target.closest(`.react-flow__node[data-id="${nodeId}"] .pcv-node-inner`))
}
